'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nuiIntl = require('@concur/nui-intl');

var _reactRouter = require('react-router');

var _utils = require('../utils');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Help = require('./Help');

var _Help2 = _interopRequireDefault(_Help);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HelpContainer = function (_Component) {
  _inherits(HelpContainer, _Component);

  function HelpContainer() {
    _classCallCheck(this, HelpContainer);

    return _possibleConstructorReturn(this, (HelpContainer.__proto__ || Object.getPrototypeOf(HelpContainer)).apply(this, arguments));
  }

  _createClass(HelpContainer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'details-container' },
        _react2.default.createElement(_reactHelmet2.default, { title: this.context.getTitle('Help') }),
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            {
              to: (0, _utils.getAppCenterPathName)(this.props.location.pathname),
              onClick: function onClick() {
                return document.title = _this2.context.getTitle(_utils.HOME);
              } },
            _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'BackToAppCenter' })
          )
        ),
        _react2.default.createElement(_Help2.default, null)
      );
    }
  }]);

  return HelpContainer;
}(_react.Component);

HelpContainer.contextTypes = {
  getTitle: _propTypes2.default.func
};

exports.default = HelpContainer;


//////////////////
// WEBPACK FOOTER
// ./lib/help/HelpContainer.js
// module id = 599
// module chunks = 0